import { render, staticRenderFns } from "./PgNormalHistory.vue?vue&type=template&id=68288d50&scoped=true&"
import script from "./PgNormalHistory.vue?vue&type=script&lang=js&"
export * from "./PgNormalHistory.vue?vue&type=script&lang=js&"
import style0 from "./PgNormalHistory.vue?vue&type=style&index=0&id=68288d50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68288d50",
  null
  
)

export default component.exports